export default "data:image/svg+xml,bq-bo.svg"